var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.99988C10 4.46944 10.2107 3.96074 10.5858 3.58566C10.9609 3.21059 11.4696 2.99988 12 2.99988C12.5304 2.99988 13.0391 3.21059 13.4142 3.58566C13.7893 3.96074 14 4.46944 14 4.99988C15.1484 5.54291 16.1274 6.3882 16.8321 7.44518C17.5367 8.50215 17.9404 9.73095 18 10.9999V13.9999C18.0753 14.6216 18.2954 15.2169 18.6428 15.738C18.9902 16.2591 19.4551 16.6913 20 16.9999H4C4.54494 16.6913 5.00981 16.2591 5.35719 15.738C5.70457 15.2169 5.92474 14.6216 6 13.9999V10.9999C6.05956 9.73095 6.4633 8.50215 7.16795 7.44518C7.8726 6.3882 8.85159 5.54291 10 4.99988",
    stroke: "#474F57",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.9999V17.9999C9 18.7955 9.31607 19.5586 9.87868 20.1212C10.4413 20.6838 11.2044 20.9999 12 20.9999C12.7956 20.9999 13.5587 20.6838 14.1213 20.1212C14.6839 19.5586 15 18.7955 15 17.9999V16.9999",
    stroke: "#474F57",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.528df7a8.svg";
export { ForwardRef as ReactComponent };